<i18n>
{
  "en": {
    "sections": "Sections",
    "section": "Section",
    "edit": "Edit",
    "delete": "Delete",
    "name": "Name",
    "description": "Description",
    "hide": "Hide",
    "show": "Show",
    "errorSections": "The section is empty"
  },
  "es": {
    "sections": "Secciones",
    "section": "Sección",
    "edit": "Editar",
    "delete": "Eliminar",
    "name": "Nombre",
    "description": "Descripción",
    "hide": "Ocultar",
    "show": "Mostrar",
    "errorSections":  "La seccion esta vacia"
  }
}
</i18n>

<template>
  <dynameat-row :title="section.title" :button-config-list="buttonConfigList"
                :collapse-items="!$vuetify.breakpoint.mdAndUp" @click-content="onClickContent"
                @edit="onEdit" @delete="onDelete" @hide="onHideSection" @show="onShowSection">
    <template v-slot:rowIconsLeft v-if="!isManaged">
      <v-list-item-action class="d-flex flex-column">
        <v-btn icon @click="onMoveUp" :disabled="isArrowUpDisabled">
          <v-icon color="grey">fa-sort-up</v-icon>
        </v-btn>
        <v-icon color="grey" small class="grip-lines-position"> fa-grip-lines</v-icon>
        <v-btn icon @click="onMoveDown" :disabled="isArrowDownDisabled">
          <v-icon color="grey">fa-sort-down</v-icon>
        </v-btn>
      </v-list-item-action>
    </template>
    <template v-slot:aboveContent>
      <v-row align="center" class="chip-top">
        <v-tooltip v-if="!hasChildren" top>
          <template v-slot:activator="{ on, attrs }">
              <v-icon v-on="on" v-bind="attrs" color="red">mdi-alert-circle</v-icon>
          </template>
          <span>{{ $t('errorSections') }}</span>
        </v-tooltip>
      </v-row>
    </template>
    <template v-slot:rowIconsRight>
      <v-tooltip v-if="!section.is_visible" top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon @click="onShowSection" v-on="on" v-bind="attrs">
<!--                 :disabled="section.has_managed_products">-->
            <v-icon color="grey">mdi-eye-off</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('show') }}</span>
      </v-tooltip>
      <v-tooltip v-else top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon @click="onHideSection" v-on="on" v-bind="attrs">
<!--                  :disabled="section.has_managed_products">-->
            <v-icon color="grey">mdi-eye</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('hide') }}</span>
      </v-tooltip>
    </template>
  </dynameat-row>
</template>

<script>

import DynameatRow from '@dynameat/components/DynameatRow';
import { Prop } from 'vue-property-decorator';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Components } from '@core/helpers/decorators';
import { Section } from '../models';

@Component
@Components({ DynameatRow })
export default class SectionRow extends Vue {
  @Prop({ Number, default: 0 }) index;

  @Prop({ Boolean, default: true }) isManaged;

  @Prop({ Number, default: 0 }) size;

  @Prop({ Object, validator(section) { return section instanceof Section; } }) section;

  get isArrowUpDisabled() {
    return this.index === 0;
  }

  get isArrowDownDisabled() {
    return this.index === (this.size - 1);
  }

  get buttonConfigList() {
    const configList = [];
    if (!this.isManaged) {
      configList.push({ title: `${this.$t('edit')}`, icon: 'mdi-pencil', emitName: 'edit' });
      configList.push({ title: `${this.$t('delete')}`, icon: 'mdi-delete', emitName: 'delete' });
    } else if (this.section.parent_section !== null) {
      // Hide edit option in clauses that are in a managed menu:
      configList.push({ title: `${this.$t('edit')}`, icon: 'mdi-pencil', emitName: 'edit' });
    }
    return configList;
  }

  get hasChildren() {
    const { sections, products } = this.section;
    return sections.length > 0 || products.length > 0;
  }

  onEdit() {
    this.$emit('edit');
  }

  onDelete() {
    this.$emit('delete');
  }

  onMoveUp() {
    this.$emit('moveup');
  }

  onMoveDown() {
    this.$emit('movedown');
  }

  onClickContent() {
    this.$emit('click-content');
  }

  onHideSection() {
    this.$emit('hide-section');
  }

  onShowSection() {
    this.$emit('show-section');
  }
}
</script>
<style>
.grip-lines-position {
  margin-right: 10px;
}
.chip-top {
  margin-top: 5px;
  margin-left: 0;
}
</style>
